(() => {
  const BAR = '[data-w1gk-shipping-bar]';
  const TEXT = '[data-w1gk-shipping-text]';
  const FILL = '[data-w1gk-shipping-fill]';

  function formatPln(cents) {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN',
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  async function refreshBars() {
    const bars = document.querySelectorAll(BAR);
    if (!bars.length) return;

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      const total = cart.total_price || 0;

      bars.forEach((bar) => {
        const threshold = Number(bar.dataset.threshold || 30000);
        const textEl = bar.querySelector(TEXT);
        const fillEl = bar.querySelector(FILL);
        if (!textEl || !fillEl || threshold <= 0) return;

        const remaining = threshold - total;
        const unlocked = remaining <= 0;
        const percent = unlocked ? 100 : Math.min(100, Math.round((total * 100) / threshold));

        bar.classList.toggle('w1gk-cart-shipping--unlocked', unlocked);
        fillEl.style.width = `${percent}%`;

        const progressTpl = bar.dataset.progressTpl || 'Brakuje {amount} do darmowej wysyłki';
        const unlockedText = bar.dataset.unlockedText || 'Masz darmową wysyłkę!';

        if (unlocked) {
          textEl.textContent = unlockedText;
        } else {
          textEl.textContent = progressTpl.replace('{amount}', formatPln(remaining));
        }
      });
    } catch (_) {}
  }

  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  async function addUpsell(button) {
    const card = button.closest('[data-w1gk-upsell-card]');
    const sizeSelect = card && card.querySelector('[data-w1gk-upsell-size]');
    const variantId = Number((sizeSelect && sizeSelect.value) || button.dataset.variantId);
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const sections = cartSectionIds();
      const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();
      if (!res.ok || data.status) {
        button.disabled = false;
        button.classList.remove('is-loading');
        return;
      }

      button.classList.add('is-added');
      button.textContent = 'Dodano';
      button.dataset.variantId = String(variantId);
      if (sizeSelect) sizeSelect.disabled = true;

      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = cartRes.ok ? await cartRes.json() : data;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'w1gk-cart-upsell',
            data: {
              source: 'w1gk-cart-upsell',
              productId: button.dataset.productId,
              variantId: String(variantId),
              itemCount: 1,
              sections: data.sections || {},
            },
          },
        })
      );

      refreshBars();
    } catch (_) {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  function syncUpsellSize(select) {
    const card = select.closest('[data-w1gk-upsell-card]');
    if (!card) return;
    const option = select.options[select.selectedIndex];
    const btn = card.querySelector('[data-w1gk-upsell-add]');
    const price = card.querySelector('[data-w1gk-upsell-price]');
    if (btn) btn.dataset.variantId = select.value;
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  }

  function syncTermsGate() {
    const boxes = document.querySelectorAll('[data-w1gk-cart-terms]');
    boxes.forEach((wrap) => {
      const input = wrap.querySelector('[data-w1gk-cart-terms-input]');
      const hint = wrap.querySelector('[data-w1gk-cart-terms-hint]');
      const footer = wrap.closest('[data-w1gk-cart-footer]') || wrap.parentElement;
      const checkout = footer && footer.querySelector('[data-w1gk-cart-checkout], #checkout');
      if (!input || !checkout) return;

      const accepted = input.checked;
      wrap.classList.toggle('is-invalid', !accepted && wrap.dataset.w1gkTried === '1');
      checkout.classList.toggle('is-terms-blocked', !accepted);
      if (hint) hint.hidden = accepted || wrap.dataset.w1gkTried !== '1';
    });
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  function boot() {
    refreshBars();
    syncTermsGate();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-w1gk-upsell-add]');
    if (btn) {
      e.preventDefault();
      addUpsell(btn);
      return;
    }

    const checkout = e.target.closest('[data-w1gk-cart-checkout], #checkout');
    if (!checkout) return;

    const footer = checkout.closest('[data-w1gk-cart-footer]');
    const wrap = footer && footer.querySelector('[data-w1gk-cart-terms]');
    const input = wrap && wrap.querySelector('[data-w1gk-cart-terms-input]');
    if (!input) return;

    if (!input.checked) {
      e.preventDefault();
      e.stopPropagation();
      wrap.dataset.w1gkTried = '1';
      syncTermsGate();
      input.focus();
    }
  }, true);

  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('[data-w1gk-upsell-size]')) {
      syncUpsellSize(e.target);
      return;
    }
    if (e.target && e.target.matches('[data-w1gk-cart-terms-input]')) {
      const wrap = e.target.closest('[data-w1gk-cart-terms]');
      if (wrap && e.target.checked) wrap.dataset.w1gkTried = '0';
      syncTermsGate();
    }
  });

  document.addEventListener('cart:update', (e) => {
    refreshBars();
    syncTermsGate();

    const source = e.detail && e.detail.data && e.detail.data.source;
    if (source === 'product-form-component' || source === 'product-form' || source === 'w1gk-cart-upsell') {
      openCartDrawer();
    }
  });
  document.addEventListener('cart:change', () => {
    refreshBars();
    syncTermsGate();
  });
  document.addEventListener('theme:cart-update', () => {
    refreshBars();
    syncTermsGate();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
